import Taro from '@tarojs/taro-h5'
export * from '@tarojs/taro-h5'

export default Taro
